import { render } from "./SelectVideoForm.vue?vue&type=template&id=52c41755&ts=true"
import script from "./SelectVideoForm.vue?vue&type=script&lang=ts"
export * from "./SelectVideoForm.vue?vue&type=script&lang=ts"

import "./SelectVideoForm.vue?vue&type=style&index=0&id=52c41755&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__